import React from 'react';
import { CookiesProvider, Cookies } from 'react-cookie';
import Constants from '../../../../configurations/constants';
import Messages from '../../../../configurations/messages';

class DisputeModalActions extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            selectedAction: null,
            neverAsk: false
        }
        this.cookies = new Cookies();
    }



    handleActionClick(actionObject) {
        let cookies  = this.cookies;
        if (cookies.get(`${Constants.COOKIE_PREFIX_NEVER_ASK}${actionObject.action}`)) {
            actionObject.handler(actionObject);
        }
        else {
            if (!this.state.selectedAction) {
                this.setState({ selectedAction: actionObject });
            } else {
                if (this.state.neverAsk) {
                    cookies.set(`${Constants.COOKIE_PREFIX_NEVER_ASK}${actionObject.action}`, "true", { path: "/" });
                }
                actionObject.handler(actionObject);

            }
        }

    }


    render() {
        return (
            <CookiesProvider>
                <div>
                    {
                        !this.state.selectedAction &&
                        <div className="dispute-modal-actions">
                            {
                                //Sort and Render Action Buttons
                                this.props.actions && !this.state.selectedAction && this.props.actions.sort((a, b) => { return a.action < b.action ? -1 : a.action > b.action ? 1 : 0 }).map((actionObject) => {
                                   
                                    return <button key={actionObject.action} onClick={(evt) => { this.handleActionClick(actionObject) }} disabled={this.props.disabled} className="btn btn-primary">{actionObject.action}</button>
                                })

                            }

                            {
                                this.props.hasCancel && this.props.cancelHandler && <button onClick={(evt) => { this.props.cancelHandler(evt) }} disabled={this.props.disabled} className="btn btn-danger">CLOSE</button>
                            }
                        </div>
                    }
                    {
                        this.state.selectedAction &&
                        <div className="mod-footer">
                            <div className="action-warning">
                               {Messages.ACTION_WARNING} "<strong>{this.state.selectedAction.action}</strong>" ?
                            </div>
                            <div className="mod-footer-buttons">
                                <button onClick={(evt) => { this.setState({ neverAsk: false, selectedAction: null }) }} disabled={this.props.disabled} className="btn btn-danger">CANCEL</button>
                                <button onClick={(evt) => { this.handleActionClick(this.state.selectedAction) }} disabled={this.props.disabled} className="btn btn-primary">{this.state.selectedAction.action}</button>
        
                            </div>
                             <div className="checkbox never-ask">
                                <label>
                                    <input type="checkbox" onChange={(event) => { this.setState({ neverAsk: event.target.checked }) }} />
                                    <span className="lbl">{Messages.ACTION_NEVER_ASK}</span>
                                </label>
                            </div>

                        </div>
                    }
                </div>
            </CookiesProvider>
        );
    }
};

export default DisputeModalActions;


// WEBPACK FOOTER //
// ./src/components/disputeMgmt/disputes/modal/disputeModalActions.js